import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { sectionCardStyles as styles } from "./styles";

// A section that has nothing to show is omitted entirely by the caller
// (never rendered as a hollow card) — see each card's own "every field
// empty" check.
const SectionCard = ({ title, action, children }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);

  return (
    <Box sx={styles.root(colors)}>
      <Box sx={styles.head(colors)}>
        <Typography sx={styles.headTitle(colors)}>{title}</Typography>
        {action}
      </Box>
      <Box sx={styles.body}>{children}</Box>
    </Box>
  );
};

export default SectionCard;
